import React from 'react'
import { useField } from 'formik'
import DatePicker from 'react-datepicker'
import { Form } from 'react-bootstrap'
import { FormGroup } from 'components'
import { _ } from 'utils'
import styled from 'styled-components'
import InfoTooltip from 'components/InfoTooltip'
import { DateProps } from '../types'

const S = {
    InfoTooltip: styled(InfoTooltip)`
        position: absolute;
        top: 33px;
        right: 20px;
    `
}

const DateField = ({
    label,
    helperText,
    isRequired,
    name,
    dateFormat = 'MMM do, yyyy',
    shouldCloseOnSelect,
    lg,
    md,
    sm,
    showInfoIcon,
    ...props
}: DateProps) => {
    const [
        field, meta, helper
    ] = useField({ name })
    const { error, touched } = meta

    return (
        <FormGroup
            controlId={`${field.name}-select-field`}
            lg={lg}
            md={md}
            sm={sm}
            className="position-relative"
        >
            <Form.Label>
                {label}
                {isRequired && <span>&nbsp;*</span>}
            </Form.Label>
            <DatePicker
                {...field}
                {...props}
                autoComplete="off"
                dateFormat={dateFormat}
                selected={(field.value && new Date(field.value)) || null}
                onChange={(val) => {
                    helper.setValue(val)
                    helper.setTouched(true)
                }}
                onBlur={() => helper.setTouched(true)}
            />

            {showInfoIcon && <S.InfoTooltip size={22} text={helperText} />}
            {!(touched && error) && !showInfoIcon && (
                <Form.Text muted>
                    {helperText}
                </Form.Text>
            )}

            {touched && error && <small className="text-danger invalid-field">{_(error)}</small>}
        </FormGroup>
    )
}

export default DateField
